{
  "daytime": {
    "earlier": "AM",
    "later": "PM"
  },
  "login": {
    "title": "Iniciar session",
    "text": "Iniciar session ath tòn compde",
    "button": "Iniciar session",
    "stressLevel": "Nivèu d'estrès",
    "errorDialog": {
      "message": "Nòm d'usatgèr o contrasenya incorrècta!",
      "accept": "D'acòrd"
    },
    "placeholder": {
      "username": "Se te platz, introdusís eth tòn nòm d'usatgèr",
      "password": "Se te platz, introdusís era tua contrasenya"
    }
  },
  "sidebar": {
    "bulletins": "Avalanche.report",
    "dangerSources": "Hònts de perilh",
    "observations": "Observacions",
    "incidents": "Incidents",
    "qfa": "QFA",
    "modelling": "Modelitzacion",
    "modellingForecast": "Prediccion",
    "modellingZamg": "Modèl multiple ZAMG",
    "modellingZamgECMWF": "ZAMG ECMWF-EPS",
    "modellingZamgCLAEF": "ZAMG CLAEF-EPS",
    "modellingZamgMeteogram": "meteograma GeoSphere",
    "modellingSnowpack": "Modèl SNOWPACK",
    "modellingSnowpackMeteo": "Modèl meteo SNOWPACK",
    "awsome": "AWSOME",
    "snowpack": "SNOWPACK",
    "geosphere": "GeoSphere",
    "lineaexport": "LINEA",
    "awsstats": "AWS Stats",
    "yearlystats": "Yearly Stats",
    "graphics": "Graphics",
    "icon": "Temps atmosferic"
  },
  "weather": {
    "loading": "Loading weather parameters and images...",
    "noPng": "Image not found.",
    "error": {
      "noParameters": "No forecast parameters available.",
      "loadFailed": "Could not load forecast data."
    },
    "headings": {
      "model": "Model",
      "modelRun": "Model run",
      "region": "Region",
      "parameters": "Parameters",
      "level": "Level"
    },
    "alt": {
      "fallback": "Forecast map",
      "image": "{{model}} {{parameter}}{{level}} {{region}} {{date}} {{hour}}Z"
    },
    "models": {
      "icon": "ICON",
      "gfs": "GFS"
    },
    "regions": {
      "atlantic": "Atlantic",
      "europe": "Europe",
      "alps": "Alps",
      "euregio": "EUREGIO"
    },
    "levels": {
      "surface": "Surface",
      "cloudTotal": "Total",
      "cloudHigh": "High",
      "cloudMid": "Mid",
      "cloudLow": "Low"
    },
    "tooltips": {
      "levelApproxElevation": "Approx. elevation: ~{{height}} m"
    },
    "parameters": {
      "gfs": {
        "equivalentPotentialTemp": "Equivalent Potential Temp.",
        "relativeHumidity": "Relative Humidity",
        "geopotentialAndIsotachs": "Geopotential and Isotachs",
        "precipitation": "Precipitation",
        "cape": "CAPE"
      },
      "icon": {
        "cloudCover": "Cloud Cover",
        "ns": "Precipitation 1h",
        "ns24": "Precipitation 24h",
        "nsacc": "Acc. Precipitation",
        "nsprob24gt20": "Prob. Prec. > 20 mm / 24h",
        "nsprob24gt40": "Prob. Prec. > 40 mm / 24h",
        "nsprob24gt80": "Prob. Prec. > 80 mm / 24h",
        "d2m": "Dew Point 2m",
        "gust": "Max. Wind Gust 10m",
        "cape": "MU-CAPE"
      }
    }
  },
  "menu": {
    "logout": "Barrar session",
    "language": "Lengua",
    "en": "Anglés",
    "de": "Alemand",
    "fr": "Francés",
    "it": "Italian",
    "es": "Castelhan",
    "ca": "Catalan",
    "oc": "Aranès",
    "fullscreen": "Pantalha complèta",
    "settings": "Configuracion",
    "statistics": "Estadístiques",
    "admin": "Administrador",
    "region": "Region",
    "education": "Educacion"
  },
  "matrix": {
    "label": {
      "snowpackStability": "Estabilitat deth celh de nhèu",
      "frequency": "Frecuéncia",
      "avalancheSize": "Mida de lauet",
      "dangerRating": "Grad de perilh",
      "override": "(modifique eth grad de perilh)",
      "matrix": "Matritz",
      "referToFairStability": "Referir-se a una estabilitat regular",
      "referToPoorStability": "Referir-se a una pobre estabilitat",
      "dangerLevel1": "Grad de perilh 1 (Fèble)"
    }
  },
  "dangerSources": {
    "status": {
      "missing": "absent",
      "available": "disponible",
      "forecast": "prediccion",
      "analysis": "analisis",
      "loading": "En tot cargar es hònts de perilh ...",
      "saveError": "Era hònt de perilh non s'a pas pogut sauvar!",
      "loadDangerSourcesError": "Era hònt de perilh non s'a pas pogut cargar!",
      "loadVariantsError": "Es variantes d'hònt de perilh non s'an pas pogut cargar!",
      "noTitle": "<no title>"
    },
    "variantStatus": {
      "active": "actiu",
      "dormant": "latent",
      "inactive": "inactiu"
    },
    "tooltip": {
      "read": "Liéger es hònts de perilh",
      "edit": "Editar es hònts de perilh"
    },
    "table": {
      "loadMore": "Condar {{count}} mès dies",
      "title": {
        "forecast": "Prediccion",
        "analysis": "Analisis"
      }
    },
    "create": {
      "variantStatus": "Estat",
      "variantEditable": "Aquesta varianta pòt èster modificada.",
      "variantNotEditable": "Aquesta varianta non pòt pas èster modificada.",
      "noVariantsForSelectedDay": "Cap de varianta definida per aguesta data.",
      "tooltip": {
        "editDangerSource": "Editar hònt de perilh",
        "loadVariants": "Cargar es variantes deth dia d'abans",
        "loadVariantsFromForecast": "Load variants from forecast",
        "showVariantsOnMap": "Mostrar es variantes en mapa",
        "edit": "Editar micro-regions",
        "copy": "Copiar varianta",
        "delete": "Esborrar varianta",
        "compare": "Comparar varianta",
        "forecast": "Comparar damb era prediccion"
      },
      "createDangerSource": "Crear hònt de perilh",
      "createVariant": "Crear naua varianta",
      "noDangerSources": "Sense hònts de perilh",
      "title": {
        "slab": "Placa",
        "weakLayer": "Capa fèbla",
        "loose": "Nhèu sense coesion",
        "glide": "Esguitlament de nhèu",
        "matrix": "Mairitz",
        "characteristics": "Caracteristiques",
        "comment": "Comentari",
        "uncertainties": "Incertituds"
      },
      "label": {
        "glidingSnowActivity": "Activitat d'esguitlament de nhèu",
        "snowHeight": "Nautada de nhèu",
        "snowHeightLowerLimit": "Min snow height",
        "snowHeightUpperLimit": "Max snow height",
        "snowHeightAverage": "Nautada de nhèu mejana",
        "zeroDegreeIsotherm": "Isotèrma 0ºC",
        "looseSnowMoisture": "Umiditat dera nhèu sense coesion",
        "looseSnowGrainShape": "Forma de gran dera nhèu sense coesion",
        "slabGrainShape": "Forma de gran dera placa",
        "slabThickness": "Celh dera placa",
        "slabThicknessLowerLimit": "Min slab thickness",
        "slabThicknessUpperLimit": "Max slab thickness",
        "slabHandHardness": "Duresa de man dera placa",
        "slabHandHardnessLowerLimit": "Min slab hand hardness",
        "slabHandHardnessUpperLimit": "Max slab hand hardness",
        "slabHardnessProfile": "Duresa dera placa",
        "slabEnergyTransferPotential": "Potenciau de transferencia d'energia dera placa",
        "slabDistribution": "Distribucion dera placa",
        "weakLayerGrainShape": "Forma de gran dera capa fèbla",
        "weakLayerGrainShapes": "Weak layer grain shapes",
        "weakLayerGrainSize": "Mesura de gran dera capa fèbla",
        "weakLayerGrainSizeLowerLimit": "Min weak layer grain size",
        "weakLayerGrainSizeUpperLimit": "Max weak layer grain size",
        "weakLayerPersistent": "Capa fèbla persistent",
        "weakLayerThickness": "Celh dera capa fèbla",
        "weakLayerStrength": "Resisténcia dera capa fèbla",
        "weakLayerWet": "Capa fèbla umida",
        "weakLayerCrustAbove": "Capa fèbla costra ath dessús",
        "weakLayerCrustBelow": "Capa fèbla costra ath dejós",
        "weakLayerPosition": "Posicion dera capa fèbla",
        "weakLayerCreation": "Creacion dera capa fèbla",
        "weakLayerDistribution": "Distribucion dera capa fèbla",
        "dangerSpotRecognizability": "Reconeissença de punts de perilh",
        "remoteTriggering": "Desencadenament a distància",
        "hasDaytimeDependency": "Dependéncia ora deth dia",
        "dangerIncreaseWithElevation": "Perilh en aument damb era nautada",
        "runoutIntoGreen": "Zòna d'arribada en verd",
        "penetrateDeepLayers": "Penetrar en capes prigondes",
        "highestDangerAspect": "Orientacion damb eth perilh mès naut",
        "dangerPeak": "Pic de perilh",
        "slopeGradient": "Grad d'inclinacion",
        "naturalRelease": "Desencadenament naturau",
        "terrainTypes": "Tipes de terren",
        "dangerSigns": "Senhaus de perilh",
        "aspects": "Orientacions"
      },
      "createDangerSourceDialog": {
        "title": "Títol",
        "description": "Descripcion",
        "save": "Sauvar",
        "cancel": "Anullar"
      },
      "editDangerSourceDialog": {
        "title": "Títol",
        "description": "Descripcion",
        "update": "Actualizacion",
        "cancel": "Anullar"
      },
      "deleteVariantDialog": {
        "message": "Vòs suprimir aguesta varianta ?",
        "accept": "Òc",
        "reject": "Non"
      },
      "noRegionDialog": {
        "message": "Au mens una microregion a d'èster tua.",
        "accept": "D'acòrd"
      },
      "discardDialog": {
        "message": "Vòs escartar es cambiaments?",
        "accept": "Òc",
        "reject": "Non"
      },
      "saveErrorDialog": {
        "message": "I a agut un error en moment de sauvar es hònts de perilh!",
        "accept": "D'acòrd"
      },
      "loadDialog": {
        "message": "Do you want to load all danger source variants from the day before?<br><strong>Existing analysis variants will be overwritten.</strong>",
        "accept": "Òc",
        "reject": "Non"
      },
      "loadFromForecastDialog": {
        "message": "Do you want to load all variants from the forecast?<br><strong>Existing analysis variants will be overwritten.</strong>",
        "accept": "Òc",
        "reject": "Non"
      }
    }
  },
  "avalancheType": {
    "title": "Tipe de lauet",
    "slab": "slab",
    "loose": "loose",
    "glide": "glide",
    "cornice": "cornisa",
    "unknown": "desconeishut",
    "label": {
      "slab": "PLACA",
      "loose": "SENSE COESION",
      "glide": "ESGUITLAMENT"
    },
    "tooltip": {
      "slab": "Lauet de placa",
      "loose": "Lauet sense coesion",
      "glide": "Lauet d'esguitlament basau"
    }
  },
  "elevation": {
    "title": "Nautada",
    "high": "Enjós",
    "low": "Dessús",
    "treeline": "Limit deth bòsc"
  },
  "bulletins": {
    "title": "Avalanche.report",
    "tooltip": {
      "edit": "Editar bulletin",
      "read": "Liéger bulletin",
      "copy": "Copiar bulletin",
      "paste": "Colar bulletin",
      "cancel": "Cancelar copia",
      "update": "Editar",
      "submit": "Enviar",
      "submitUpdate": "Enviar actualizacion",
      "publishChange": "Publicar ara (sense messatges)",
      "publishUpdate": "Publicar ara",
      "publishMinimal": "Minimal publication",
      "caaml": "Mostrar CAAML",
      "json": "Mostrar JSON",
      "create": "Crear bulletin",
      "preview": "Vista previa deth bulletin (PDF)",
      "check": "Verificar bulletin",
      "info": "Mostrar er estat de publicacion",
      "loadSuggestionFromDangerSources": "Load suggestion from danger sources",
      "deleteAllWarningRegions": "Suprimir totes es regions d'alèrta",
      "publishAll": "Publicar totes es regions",
      "publishAllNoMessages": "Publicar totes es regions (sense missatges)",
      "mediaFile": "Cargar un fichèr multimèdia",
      "publicationChecklist": "Open publication checklist"
    },
    "publicationChecklist": {
      "title": "Publication checklist",
      "description": {
        "website": "The map on the website shows the danger levels with their corresponding colors. Clicking on a region shows the avalanche problems and texts.",
        "email": "An email was sent and contains a report.",
        "telegram": "A message containing a link to the website was posted.",
        "whatsapp": "A message containing a link to the website was posted."
      },
      "ok": "Òc ben",
      "problem": "Problem",
      "problemDescription": "Problem description",
      "problemPlaceholder": "Describe the encountered problem",
      "channel": {
        "website": "Website",
        "whatsapp": "WhatsApp",
        "telegram": "Telegram",
        "email": "Corrèu electronic"
      },
      "publicationInProgress": "Publication in progress",
      "publicationFinishedOnServer": "Finished publication on server",
      "publishDisabled": {
        "inProgress": "Publication is currently in progress.",
        "wrongStatus": "The bulletin must be submitted or published."
      },
      "emailWaitHint": "Email delivery usually takes longer than social media messages. At least 5 minutes should have passed since publication before you proceed to the next step.",
      "email": {
        "waitTitle": "Wait:"
      },
      "options": "Options",
      "republish": "Republish:",
      "resend": "Resend:",
      "website": {
        "checkInternetTitle": "Check internet connection:",
        "checkInternetDescriptionPrefix": "How is the internet connection on your device? Open",
        "checkInternetDescriptionSuffix": "in a private window. Is yesterday's bulletin displayed correctly?",
        "republishHint": "Only perform this step if “Check internet connection” was successful and at least 5 minutes have passed since the last publication attempt.",
        "publishMinimalTitle": "Minimal publication:",
        "publishMinimalHint": "Use this as a fallback if the full publication fails. Publishes CAAML data only — no maps, text-to-speech, or push messages. ⚠️ Also affects other regions on this server, not just your own. All will be republished in minimal mode.",
        "editAndResendTitle": "Edit and resend:",
        "openBulletin": "Open the bulletin",
        "clickEdit": "Click “Edit”",
        "clickSubmit": "Click “Submit”",
        "clickPublishNow": "Click “Publish now”"
      },
      "manualSend": {
        "title": "Manual send:",
        "description": {
          "telegram": "Copy the text below and send it to the specified Telegram group.",
          "whatsapp": "Copy the text below to the specified WhatsApp channel."
        },
        "copyText": "Copy {{language}} {{channel}} text"
      },
      "newChecklist": "New checklist",
      "savedInfo": "Saved by {{user}}, {{time}}",
      "print": {
        "contact": {
          "title": "Emergency contact",
          "emailLabel": "Email:",
          "nameLabel": "Name:",
          "phoneLabel": "Phone:"
        },
        "emergencyTitle": "If serious problems occur",
        "fallback": {
          "title": "Use fallback instance:",
          "step1": "Navigate to the fallback Admin-GUI and publish the bulletin there.",
          "step2": "Manually send messages to subscribed channels. Use the text below:",
          "step3": "Inform the public by creating social media posts linking to the fallback website URL.",
          "step4": "Inform the PR department about the situation."
        },
        "hide": "Hide print version",
        "hint": "Fill in the hosting service contact details and the fallback URLs below, then click \"Print\".",
        "hostingDescription": "Ask about server status. If applicable, request a server restart.",
        "hostingTitle": "Contact hosting service:",
        "print": "Print",
        "toggle": "Print version"
      }
    },
    "status": {
      "submittedInfo": "Serà publicat tàs 5PM",
      "resubmittedInfo": "Serà publicat tàs 8AM",
      "publishedInfo": "A estat publicat",
      "noPublicationInfo": "NON serà publicat automaticaments",
      "loadingPreview": "Creant ua vista prèvia de PDF...",
      "loading": "En tot cargar eth bulletin ...",
      "loadMoreBulletins": "Cargar {{count}} mès bulletins",
      "publishing": "Bulletin publicant-se",
      "submitting": "Bulletin enviant-se",
      "saveError": "Non s'a pogut sauvar eth bulletin!",
      "loadBulletinsError": "Non s'an pogut cargar es bulletins!"
    },
    "create": {
      "tooltip": {
        "edit": "Editar micro-regions",
        "copy": "Copiar region",
        "delete": "Esborrar region",
        "deleteProblem": "Esborrar problema",
        "compare": "Comparar region",
        "undo": "Anullar era darrièra modificacion dera region",
        "redo": "Tornar a hèr eth cambi laguens era region",
        "createRegion": "Crear region",
        "cancel": "Anullar",
        "acceptSuggestion": "Acceptar regions suggerides",
        "rejectSuggestion": "Refusar regions suggerides",
        "saveChanges": "Sauvar cambiaments",
        "discardChanges": "Escartar cambiaments",
        "incompleteAvalancheProblem": "Problèma de lauegi incomplèt",
        "saveBulletin": "Sauvar bulletin",
        "discardBulletin": "Escartar cambiaments deth bulletin",
        "loadBulletin": "Cargar bulletin deth dia anterior",
        "uploadCaamlBulletin": "Upload bulletin in CAAML format",
        "uploadJsonBulletin": "Cargar eth bulletin en format JSON",
        "downloadCaamlBulletin": "Download bulletin in CAAML format",
        "downloadJsonBulletin": "Descargar eth bulletin en format JSON",
        "daytimeDependency": "Dependéncia ora deth dia",
        "treeline": "Limit deth bòsc",
        "tendency": {
          "decreasing": "Perilh de lauegi diminuís",
          "steady": "Perilh de lauegi seguís parièr",
          "increasing": "El perill d’allaus aumente",
          "danger": "Perilh de lauegi"
        },
        "textcat": {
          "edit": "Editar",
          "copy": "Copiar",
          "paste": "Colar",
          "example": "Cargar tèxte exemple",
          "delete": "Esborrar"
        },
        "moveUpAvalancheProblem": "Eth problèma de lauegi se mostrarà ath bulletin",
        "moveDownAvalancheProblem": "Botjar eth problèma de lauegi cap enjós",
        "dangerRatingDirectionUp": "Cap ensús",
        "dangerRatingDirectionDown": "Cap enjós",
        "addPhoto": "Add photo",
        "removePhoto": "Remove photo",
        "uploadPhoto": "Upload photo",
        "editPhoto": "Edit photo"
      },
      "save": "Sauvar",
      "discard": "Escartar",
      "back": "Endarrere",
      "createAggregatedRegion": "Naua region",
      "pasteAggregatedRegion": "Enganchar era region",
      "pendingSuggestions": "Suggeriments",
      "rejectSuggestion": "Rebutjar",
      "acceptSuggestion": "Acceptar",
      "cancelCopyBulletin": " Cancelar",
      "createAvalancheProblem": "Nau problèma",
      "ownRegions": "Regions pròprias",
      "foreignRegions": "Regions estrangères",
      "externalRegions": "Regions extèrnes",
      "mapSelectRegion": "Seleccionar regions ath mapa",
      "statusHeader": "Estat deth bulletin",
      "suggestions": "Suggeriments",
      "noBulletinsForSelectedDay": "Non s'a pas definit cap de region per aguesta data.",
      "autosave": "Sauvat automaticaments",
      "regionEditable": "Aguesta region pòt editar-se.",
      "regionNotEditable": "Aguesta region non pòt pas editar-se.",
      "regionLocked": "Aguesta region ei bloquejada.",
      "changeDangerRatingElevation": "Extendre eth perilh de lauegi",
      "mapTop": "Mapa dessús",
      "mapLeft": "Mapa en costat",
      "showExternalRegions": "Mostrar regions extèrnes",
      "hideExternalRegions": "Amagar regions extèrnes",
      "showNotes": "Mostrar nòtes",
      "hideNotes": "Amagar nòtes",
      "incompleteAvalancheProblem": "Incomplèt",
      "label": {
        "generalHeadlineComment": "Títol globau generau",
        "importantObservations": "Observacions importantes",
        "avalancheProblems": "Problèma de lauegi",
        "aspects": "Orientacions",
        "highlights": "Alèrte especiau",
        "avActivityHighlights": "Titular dera situacion de lauegi",
        "avActivityComment": "Descripcion deth perilh de lauegi",
        "travelAdvisoryHighlights": "Headline travel advisory",
        "travelAdvisoryComment": "Description of travel advisory",
        "snowpackStructureHighlights": "Estructura deth celh de nhèu",
        "snowpackStructureComment": "Descripcion deth celh de nhèu",
        "dangerPatterns": "Patrons de perilh",
        "tendencyComment": "Descripcion de tendéncia",
        "synopsisHighlights": "Headline weather synopsis",
        "synopsisComment": "Sinopsi deth temps",
        "notes": "Nòtes",
        "noSnow": "Sense nhèu"
      },
      "copyRegion": {
        "label": "Copiar era region d'alèrta a un aute bulletin",
        "select": "Enganchar a ...",
        "currentBulletin": "Aguest bulletin"
      },
      "title": {
        "avalancheProblem": "Problèmes de lauegi",
        "dangerDescription": "Descripcion deth perilh de lauegi",
        "forenoon": "Maitin",
        "afternoon": "Tarde",
        "photos": "Photos",
        "snowpackStructure": "Estructura deth celh de nhèu",
        "tendency": "Tendéncia",
        "synopsis": "Temps atmosferic",
        "showTranslations": "Mostrar revirades",
        "hideTranslations": "Amagar revirades"
      },
      "photos": {
        "url": "Image URL",
        "locationName": "Localitat",
        "microregion": "Microregion",
        "copyright": "Copyright",
        "date": "Data"
      },
      "placeholder": {
        "notes": "Escriu ací ..."
      },
      "pmDialog": {
        "noIFrameSupport": "Eth tòn navigador non ei compatible damb IFrames."
      },
      "discardDialog": {
        "message": "Vòs escartar es cambiaments?",
        "accept": "Òc",
        "reject": "Non"
      },
      "deleteAggregatedRegionDialog": {
        "message": "Vòs esborrar aquesta region?",
        "accept": "Òc",
        "reject": "Non"
      },
      "noRegionDialog": {
        "message": "Au mens una microregion a d'èster vòstra.",
        "accept": "D'acòrd"
      },
      "loadDialog": {
        "message": "Do you want to load the bulletins from the day before?<br><strong>This will delete all existing regions!</strong>",
        "accept": "Òc",
        "reject": "Non"
      },
      "deleteAllWarningRegionsDialog": {
        "message": "Vòs suprimir totes es regions d'alèrta ?",
        "accept": "Òc",
        "reject": "Non"
      },
      "loadSuggestionsFromDangerSourcesDialog": {
        "message": "Do you want to load suggestions from danger sources?<br><strong>This will delete all existing regions!</strong>",
        "accept": "Òc",
        "reject": "Non"
      },
      "loadAutoSaveDialog": {
        "message": "Vòs cargar es bulletins sauvadi automaticaments?",
        "accept": "Òc",
        "reject": "Non"
      },
      "saveErrorDialog": {
        "message": "S'a produsit un error en sauvar es bulletins!",
        "accept": "D'acòrd"
      },
      "changeErrorDialog": {
        "message": "S'a produsit un error en cambiar es bulletins!",
        "accept": "D'acòrd"
      },
      "loadingErrorDialog": {
        "message": "S'a produsit un error en cargar es bulletins!",
        "accept": "D'acòrd"
      },
      "loadingJsonFileErrorDialog": {
        "message": "S'a produsit un error en cargar es bulletins dempús deth fichèr JSON!",
        "accept": "D'acòrd"
      },
      "avalancheProblemErrorDialog": {
        "message": "Manque eth problèma de lauegi, orientacions, estabilitat deth celh de nhèu, frequéncia e/o era mesura de lauet per aumens un problèma de lauegi",
        "accept": "D'acòrd"
      },
      "loadAvActivityCommentExampleTextDialog": {
        "message": "Entà quina situacion vòs cargar un tèxte d'exemple?",
        "newSnow": "Nhèu recenta",
        "windSlab": "Plaques de vent",
        "persistentWeakLayers": "Coches fèbles persistentes",
        "wetSnow": "Nhèu umida",
        "glidingSnow": "Esguitlaments basaus",
        "favourableSituation": "Situacion favorabla",
        "cancel": "Anullar"
      },
      "removeDaytimeDependencyDialog": {
        "message": "Quins problèmes de lauegi vòs sauvar?",
        "cancel": "Anullar"
      },
      "strategicMindsetDialog": {
        "title": "Predisposicions mentaus estrategiques",
        "introduction": "Es \"Predisposicions Mentaus Estrategiques\" assagen d'expressar era nòstra actitud mentala respècte era situacion de lauegi e deth son desvolopament laguens era region d'alèrta correspondenta. Non auríe pas d'èster derivada dirèctament dera avaloracion deth risc, mès compréses e utilizades coma una impression intuitiva dera situacion globala. Es \"Predisposicions Mentaus Estrategiques\" son doncas subretot un estrument de comunicacion. En utilizant es predispocions mentaus e es definicions associades, nosati es predictors podèm rapidament e eficaçament escambiar informacions sus eth desvolopament dera situacion de perilh e trobar ua lengua comuna entara comunicacion.",
        "description": {
          "title": "Descripcion:",
          "text": {
            "assessment": "I a ua grana incertitud ena avaloracion deth perilh a causa dera informacion insufisenta deth terren.",
            "stepping_out": "<b>Tendéncia decreissenta</b> dera situacion de perilh (tanben en un nivèu de perilh).",
            "status_quo": "Madeisha situacion perilhosa. <b>Sense cambiaments significatius</b> per çò qu'ei deth dia anterior.",
            "stepping_back": "<b>Tendéncia en aument</b> dera situacion de perilh (tanben en un nivèu de perilh).",
            "entrenchment": "<b>Situacion perilhosa, lèu constanta e tensa.</b> Eth perilh principau proven de (a) <b>capa fèbla persistenta</b>susceptibla(s) a interferir.",
            "free_ride": "<b>Perilh de lauegi fèble</b>1 damb un celh de nhèu generauments establa. Solament son possibles petiti lauegi en terrens extrèmaments arribents.",
            "high_alert": "Situacion excepcionau damb <b>perilh de lauegi fòrt o molt fòrt</b>. Son possibles lauegi naturaus de <b>magnitud fòrça grana o extrèma</b>",
            "spring_diurnal": "Es lauegi de nhèu umida pendent eth transcors deth dia, que son subjèctes a un <b>cicle diürn clar</b>, son decisives entara avaloracion deth risc."
          }
        },
        "communication": {
          "title": "Comunicacion:",
          "text": {
            "assessment": "Cau verificar localaments era situacion de lauegi. S'arrecomane restriccion.",
            "stepping_out": "Diminucion graduala deth perilh. Totun, era precaucion ei encara requerida e era situacion en melhorament deuríe èster avalorada localament abans d'entrar en terren mès arriscat.",
            "status_quo": "Era situacion de perilh ei invariable. Es comentaris des observadors ajuden a melhor esboçar era situacion perilhosa. Un terren mès favorable auríe d'èster comunicat damb remèrques.",
            "stepping_back": "Comunicacion clara der aument deth perilh de lauegi - encara laguens d'un nivèu de perilh. Era informacion sus es causes sosten era comprension ena comunicacion.",
            "entrenchment": "Cau precaucion e contencion. Era situacion quasi non càmbie. S'ei possible, proporcionatz informacion çò de mès de precís possibla sus era distribucion e era possibilitat de desencadenament. Aument dera comunicacion des observacions que revèlen era situacion e demanen contencion.",
            "free_ride": "Pòc tèxte. Destacar era situacion generau favorabla e es zònes de perilh potenciauments isolat.",
            "high_alert": "Comunicacion a trauès de toti es canaus. Era atencion ja non se centre enes espòrts d'iuèrn. Perilh en zònes que non sòlen auer risc de lauegi.",
            "spring_diurnal": "Situacion favorabla peth maitin, qu'aumentarà pendent eth dia. Cau hèr avaloracion localaments en tot observar eth reblaniment dera costra de fusion e regèu e era umidificacion deth celh de nhèu."
          }
        },
        "examples": {
          "title": "Exemples:",
          "text": {
            "assessment": "Començament dera sason.",
            "stepping_out": "Eth heiredament diminuís eth risc de lauegi de nhèu humida dempús d'ua fasa de temps caud e umit.",
            "status_quo": "Problèma consistent de plaques de vent damb temperatures heiredes, nhèu sense coesion e vent.",
            "stepping_back": "Es nheuades recents abondiues provòquen un aument dera situacion de perilh.",
            "entrenchment": "Problèma critic de capes fèbles persistentes damb potenciau de lauegi perilhosament grani. Era situacion ei en tot estabilitzar-se fòrça lentaments e requerís fòrça moderacion.",
            "free_ride": "Perilh de lauegi feble, sense capes fèbles persistentes, tot eth terren ja ei caushigat.",
            "high_alert": "Nivèu de perilh 4 o superior a causa de granes quantitats de nèu recenta e/o de capes febles persistentes, problematiques.",
            "spring_diurnal": "Situacion de primauera damb temps sec, nauta pression e temperatures moderades damb un celh de nhèu vielh majoritàriament establa."
          }
        },
        "strategicMindset": {
          "assessment": "Incertesa nauta",
          "stepping_out": "Mielhorant",
          "status_quo": "Status Quo",
          "stepping_back": "Deteriorant",
          "entrenchment": "Persistent inestable",
          "free_ride": "Favorable",
          "high_alert": "Alèrta nauta",
          "spring_diurnal": "Primauera ath long deth dia"
        }
      },
      "decisionTree": {
        "filepath": "./assets/img/decision_tree-en.svg",
        "feedbackURL": "https://admin.avalanche.report/umfrage-entscheidungsbaum/en/",
        "decisionTree": "Arbre de decisions",
        "feedback": "Comentaris",
        "save": "Sauvar",
        "discard": "Escartar"
      }
    },
    "table": {
      "title": {
        "date": "Data"
      },
      "status": {
        "missing": "absent",
        "draft": "borrolhon",
        "submitted": "enviat",
        "published": "publicat",
        "updated": "actualizat",
        "resubmitted": "re-enviat",
        "republished": "re-publicat"
      },
      "publishBulletinsDialog": {
        "message": "Vòs publicar eth bulletin?"
      },
      "publicationStatusDialog": {
        "headline": "Estat dera publicacion",
        "publishedBy": "Publicat per:",
        "publishedAt": "Publicat a les:",
        "validFor": "Valid per:",
        "title": {
          "prod": "Causes serioses",
          "test": "Test deth sistema",
          "task": "Prètzhèt",
          "language": {
            "all": "TOTI",
            "de": "DE",
            "it": "IT",
            "en": "EN"
          }
        },
        "email": {
          "label": "Emails",
          "tooltip": "Enviar Emails",
          "success": "Corrèus electronics enviadi corrèctaments!",
          "error": "Es corrèus non s'an pas pogut enviar!"
        },
        "telegram": {
          "label": "Messatges de Telegram",
          "tooltip": "Enviar messatges de Telegram",
          "success": "Messatges de Telegram enviadi corrèctaments!",
          "error": "Non s'an pogut enviar es messatges de Telegram!"
        },
        "whatsapp": {
          "label": "Messatges de WhatsApp",
          "tooltip": "Enviar messatges de WhatsApp",
          "success": "Messatges de WhatsApp enviadi corrèctaments!",
          "error": "Non s'an pogut enviar es messatges de WhatsApp!"
        },
        "push": {
          "label": "Notificacions Push",
          "tooltip": "Enviar notificacions Push",
          "success": "Notificacions Push enviades corrèctaments!",
          "error": "Non s'an pogut enviar es notificacions Push!"
        },
        "accept": "Òc ben",
        "confirm": "Do you want to send {{channel}} ({{language}})?"
      },
      "mediaFileDialog": {
        "headline": "Fichèr multimèdia",
        "important": "IMPORTANT",
        "missingFile": "Non s'a pas seleccionat cap fichèr!",
        "uploadError": "Era carga a mancat!",
        "accept": "Enviar",
        "reject": "Anullar"
      },
      "publishBulletinsErrorDialog": {
        "message": "S'a produsit un error en publicar bulletins!",
        "accept": "Òc ben"
      },
      "submitBulletinsDialog": {
        "message": "Vòs enviar eth bulletin?"
      },
      "submitBulletinsErrorDialog": {
        "message": "S'ha produït un error en enviar butlletins!",
        "accept": "d'acòrd"
      },
      "submitBulletinsDuplicateRegionDialog": {
        "message": "Regions avalorades diuèrsi còps! Non se pòt enviar eth bulletin.",
        "accept": "d'acòrd"
      },
      "checkBulletinsErrorDialog": {
        "message": "S'a produsit un error en verificar es bulletins!",
        "accept": "Òc ben"
      },
      "previewErrorDialog": {
        "message": "Non s'a pogut cargar era vista prèvia!",
        "accept": "Òc ben"
      },
      "checkBulletinsDialog": {
        "message": "Verificar eth bulletin",
        "ok": "(tot corrècte)"
      },
      "publishAllDialog": {
        "message": "Vòs publicar totes es regions?",
        "changeMessage": "Vòs publicar totes es regions? (sense messatges)"
      },
      "bulletinCheck": {
        "missingDangerRating": "Grad de perilh non establit",
        "missingDangerRatingModificator": "Danger rating modificator not set",
        "missingRegion": "Regions sense grad de perilh",
        "duplicateRegion": "Regions avalorades diuèrsi viatges",
        "missingAvActivityHighlights": "Manque eth titular dera situacion de lauegi",
        "missingAvActivityComment": "Manque era descripcion deth perilh de lauegi",
        "missingSnowpackStructureHighlights": "Manque eth titular dera estructura deth celh de nhèu",
        "missingSnowpackStructureComment": "Manque era descripcion deth celh de nhèu",
        "pendingSuggestions": "Suggeriments pendenti",
        "incompleteTranslation": "Revirada incomplèta"
      }
    }
  },
  "training": {
    "training": "Entrenament",
    "timestamp": "Mèrca de temps d'entrenament"
  },
  "admin": {
    "loadingStatistics": "Creant eth CSV ...",
    "server-configuration": {
      "title": "Servidor",
      "button": {
        "create": "Crear servidor",
        "save": "Sauvar"
      },
      "table": {
        "name": "Nòm",
        "userName": "Nòm d'usatgèr",
        "password": "Password",
        "publishAt5PM": "Publicar as 5 PM",
        "publishAt8AM": "Publicar as 8 AM",
        "pdfDirectory": "Directòri entà PDF",
        "htmlDirectory": "Directòri entà HTML",
        "serverImagesUrl": "Rota as imatges deth servidor",
        "dangerLevelElevationDependency": "Dependéncia de nautada deth nivèu de perilh",
        "mapsPath": "Rota as mapes",
        "mediaPath": "Rota des fichèrs multimèdia",
        "mapProductionUrl": "URL entara produccion de mapes",
        "apiUrl": "API URL"
      },
      "success": "Configuracion sauvada corrèctaments",
      "error": "Non s'a pogut sauvar era configuracion"
    },
    "region-configuration": {
      "title": "Region",
      "button": {
        "create": "Crear region",
        "save": "Sauvar"
      },
      "table": {
        "general": {
          "title": "Generau"
        },
        "publication": {
          "title": "Publicacion"
        },
        "components": {
          "title": "Components"
        },
        "configuration": {
          "title": "Configuracion"
        },
        "languageConfiguration": {
          "title": "Configuracion de lengües"
        }
      },
      "success": "Configuracion sauvada corrèctaments",
      "error": "Non s'a pogut sauvar era configuracion"
    },
    "users": {
      "title": "Usuaris",
      "button": {
        "create": " Crear usatgèr"
      },
      "tooltip": {
        "edit": "Editar usuari",
        "changePassword": "Cambiar contrasenya",
        "delete": "Eliminar usuari"
      },
      "table": {
        "name": "Nòm",
        "email": "Corrèu electronic",
        "organization": "Organizacion",
        "regions": "Regions",
        "roles": "Ròtles"
      },
      "deleteUserModalDialog": {
        "message": "Voletz eliminar er usatgèr?",
        "accept": "Òc",
        "reject": "Non"
      },
      "deleteUser": {
        "success": "Usatgèr eliminat",
        "error": "Er usatgèr non a pogut èster eliminat"
      },
      "createUser": {
        "success": "Usatgèr creat",
        "error": "Non s'a pogut crear er usatgèr"
      },
      "updateUser": {
        "success": "Usatgèr sauvat",
        "error": "Non s'a pogut sauvar er usatgèr"
      }
    },
    "createUser": {
      "table": {
        "image": "Imatge",
        "name": "Nòm",
        "email": "Corrèu electronic",
        "organization": "Organizacion",
        "password": "Password",
        "password2": "Repetir password",
        "roles": "Ròtles",
        "regions": "Regions"
      },
      "error": {
        "name": {
          "required": "Introduir un nòm"
        },
        "email": {
          "required": "Introduir ua adreça de corrèu electronic",
          "invalid": "Era adreça electronica non ei valida"
        },
        "password": {
          "required": "Introduir ua contrasenha",
          "length": "Era contrasenha a d'auer aumens 8 caracters",
          "mismatch": "Es contrasenhes non coïncidissen"
        }
      },
      "button": {
        "create": "Crear usuari",
        "update": "Actualizar usatgèr",
        "cancel": "Anullar"
      }
    },
    "observations": {
      "table": "Taula",
      "map": "Mapa",
      "gallery": "Galeria",
      "filters": "Filtres",
      "details": "Detalhs",
      "title": "Observacions",
      "newObservation": "Naua observacion",
      "exportObservations": "Exportar observacions (GeoJSON)",
      "exportStatistics": "Exportar estadistiques (CSV)",
      "toggleFilterBar": "Mostrar / Amagar barra de filtres",
      "button": {
        "submit": "Descargar"
      },
      "label": {
        "dateRange": "Periòde",
        "observer": "Observador"
      },
      "selectRegion": {
        "placeholder": "Region",
        "selectionLabel": "{0} region(s) seleccionades"
      },
      "selectSources": {
        "placeholder": "Hònts",
        "selectionLabel": "{0} hònt(s) seleccionades"
      },
      "charts": {
        "charts": "Grafiques",
        "nan": "Sense especificacion",
        "reload": "Recargar",
        "classify": "Classificar",
        "label": "Etiqueta",
        "invert": "Invertir",
        "reset": "Restablir",
        "aspect": {
          "caption": "Orientacion"
        },
        "elevation": {
          "caption": "Nautada"
        },
        "stability": {
          "caption": "Estabilitat"
        },
        "observationType": {
          "caption": "Tipe d'observacions"
        },
        "importantObservation": {
          "caption": "Important"
        },
        "avalancheProblem": {
          "caption": "Problèma de lauegi"
        },
        "dangerPattern": {
          "caption": "Patron de perilh"
        },
        "dangerSource": {
          "caption": "Hònt de perilh"
        },
        "days": {
          "caption": "Dia"
        }
      }
    },
    "blog": {
      "title": "Blòg",
      "language": {
        "title": "Lengua",
        "de": "DE",
        "it": "IT",
        "en": "EN"
      },
      "all": {
        "tooltip": "Enviar corrèus electronics, Telegram, WhatsApp e Push",
        "success": "Messatges de Corrèu electronic, Telegram, WhatsApp e Push enviadi corrèctaments!",
        "error": "Non s'an pogut enviar es Corrèus electronics, Telegram, WhatsApp e Push!"
      },
      "email": {
        "tooltip": "Enviar corrèus electronics",
        "success": "Corrèu electronic enviat corrèctaments!",
        "error": "Non s'a pogut enviar eth corrèu electronic"
      },
      "telegram": {
        "tooltip": "Enviat per canau de Telegram",
        "success": "Telegram enviat corrèctaments!",
        "error": "Non s'a pogut enviar eth messatge de Telegram!"
      },
      "whatsapp": {
        "tooltip": "Enviat per canau de WhatsApp",
        "success": "WhatsApp enviat corrèctaments!",
        "error": "Non s'a pogut enviar eth WhatsApp"
      },
      "push": {
        "tooltip": "Enviar per Notificacions Push",
        "success": "Push enviat corrèctaments!",
        "error": "Non s'a pogut enviar eth Push"
      }
    }
  },
  "settings": {
    "title": "Configuracion",
    "effectiveRole": "Effective role",
    "effectiveRoleDefault": "All roles",
    "changePassword": {
      "title": "Cambiar contrasenha",
      "oldPassword": {
        "label": "Contrasenha actuau",
        "placeholder": "Contrasenha actuau"
      },
      "newPassword1": {
        "label": "Naua contrasenha",
        "placeholder": "Naua contrasenha"
      },
      "newPassword2": {
        "label": "Contrasenha naua (repetir)",
        "placeholder": "Naua contrasenha"
      },
      "submit": "Cambiar contrasenha",
      "passwordChanged": "Contrasenha cambiada corrèctaments",
      "passwordChangeError": "Non s'a pogut cambiar era contrasenha",
      "passwordIncorrect": "Era contrasenha actuau ei incorrècta",
      "error": {
        "oldPassword": {
          "required": "Se te platz, entre era tua contrasenha actuau"
        },
        "newPassword": {
          "required": "Se te platz, entra ua naua contrasenha",
          "mismatch": "Es contrasenhes non coïncidissen"
        }
      }
    },
    "display": {
      "title": "Visualizacion",
      "table": {
        "showCaaml": "Mostrar CAAML",
        "showJson": "Mostrar JSON"
      }
    }
  },
  "statistics": {
    "title": "Estadístiques",
    "bulletins": "Bulletins de lauegi",
    "dangerSources": "Hònts de perilh",
    "button": {
      "submit": "Descargar"
    },
    "label": {
      "dateRange": "Periòde",
      "extended": "Estenuda",
      "duplicates": "Duplicats"
    },
    "error": {
      "downloadFailed": "The statistics export could not be downloaded. Please try again."
    }
  },
  "dangerRating": {
    "missing": "absent",
    "noRating": "Sense grad de perilh",
    "no_rating": "Sense grad de perilh",
    "no_snow": "no snow",
    "low": "fèble",
    "moderate": "moderat",
    "considerable": "mercat",
    "high": "fòrt",
    "very_high": "molt fòrt",
    "veryHigh": "molt fòrt"
  },
  "avalancheProblem": {
    "newSnow": "Nhèu recenta",
    "new_snow": "Nhèu recenta",
    "windSlab": "Plaques de vent",
    "wind_slab": "Plaques de vent",
    "persistentWeakLayers": "Coches fèbles persistentes",
    "persistent_weak_layers": "Coches febles persistentes",
    "wetSnow": "Nhèu umida",
    "wet_snow": "Nhèu umida",
    "glidingSnow": "Esguitlaments basaus",
    "gliding_snow": "Esguitlaments basaus",
    "cornices": "Cornises",
    "noDistinctAvalancheProblem": "Cap problèma de lauegi evident",
    "no_distinct_avalanche_problem": "Cap problèma de lauegi evident",
    "favourableSituation": "Situacion favorabla",
    "favourable_situation": "Situacion favorabla"
  },
  "dangerPattern": {
    "dp1": "pp.1:  capa fèbla persistenta e prigonda",
    "dp2": "pp.2: litsades basaus",
    "dp3": "pp.3: ploja",
    "dp4": "pp.4: heired dempús de caud / caud dempús de heired",
    "dp5": "pp.5: nheuades dempús d’un long periòde de heired",
    "dp6": "pp.6: nhèu heireda, sense coesion e vent",
    "dp7": "pp.7 nhèu escassa ath costat de nhèu prigonda",
    "dp8": "pp.8: geladiua de superfícia enterrada",
    "dp9": "pp.9: graupel enterrat",
    "dp10": "pp.10: scenari de primauera"
  },
  "strategicMindset": {
    "title": "Predisposicion mentau estrategica",
    "assessment": "Incertesa nauta",
    "stepping_out": "Mielhorant",
    "status_quo": "Status Quo",
    "stepping_back": "Deteriorant",
    "entrenchment": "Persistent inestable",
    "free_ride": "Favorable",
    "high_alert": "Alèrta nauta",
    "spring_diurnal": "Primauera diürn"
  },
  "observationType": {
    "DrySnowfallLevel": "Limit de nheuada seca",
    "TimeSeries": "Series temporaus",
    "Incident": "Incident",
    "Profile": "Perfil de nhèu",
    "Closure": "Barrament",
    "Blasting": "Voladura",
    "Avalanche": "Lauet",
    "Evaluation": "Avaloracion",
    "SimpleObservation": "Observacion simple",
    "Webcam": "Webcam"
  },
  "importantObservation": {
    "ForBlog": "Tath Blòg",
    "SurfaceHoar": "Gibra de superfícia",
    "Graupel": "Nhèu redona",
    "StabilityTest": "Test d'estabilitat",
    "IceFormation": "Formacion de gèu",
    "VeryLightNewSnow": "Nhèu recenta molt leugèra"
  },
  "elevationTolerance": {
    "exact": "exacte",
    "50m": "±50m",
    "100m": "±100m",
    "200": "±200m"
  },
  "elevationPeriod": {
    "duringPrecipitationEvent": "Limit de nhèu seca deth eveniment de precipitacion entièr",
    "observationPeriod": "Limit de nhèu seca ath moment dera observacion"
  },
  "aspect": {
    "N": "N",
    "NE": "NE",
    "E": "E",
    "SE": "SE",
    "S": "S",
    "SW": "SW",
    "W": "W",
    "NW": "NW"
  },
  "role": {
    "SUPERADMIN": "Super Administrador",
    "ADMIN": "Administrador",
    "FORECASTER": "Predictor",
    "FOREMAN": "Cap",
    "OBSERVER": "Observador"
  },
  "tendency": {
    "decreasing": "Perilh de lauegi diminuís",
    "steady": "Perilh de lauegi seguís parièr",
    "increasing": "El perill d’allaus aumente"
  },
  "snowpackStability": {
    "unknown": "desconeishut",
    "good": "bona",
    "fair": "regular",
    "poor": "praube",
    "very_poor": "molt praube"
  },
  "frequency": {
    "none": "(quasi) cap",
    "few": "ues pòques",
    "some": "beres ues",
    "many": "moltes"
  },
  "avalancheSize": {
    "small": "petit",
    "medium": "mejan",
    "large": "gran",
    "very_large": "molt gran",
    "extreme": "extremadament gran"
  },
  "complexity": {
    "easy": "Facil",
    "challenging": "Exigent",
    "complex": "Complèxe"
  },
  "glidingSnowActivity": {
    "low": "fèble",
    "medium": "mejan",
    "high": "fòrt"
  },
  "wetness": {
    "dry": "seca",
    "moist": "umida",
    "wet": "fòrça umida"
  },
  "characteristic": {
    "low": "fèble",
    "medium": "mejan",
    "high": "fòrt",
    "very_high": "molt fòrt"
  },
  "thickness": {
    "thin": "prim",
    "thick": "grossut"
  },
  "snowpackPosition": {
    "upper": "superior",
    "middle": "intermig",
    "lower": "inferior",
    "ground": "tèrra"
  },
  "weakLayerCrust": {
    "no": "non",
    "partly": "parciauments",
    "yes": "òc"
  },
  "creationProcess": {
    "radiation_recrystallization": "radiacion",
    "diurnal_recrystallization": "diürn",
    "melt_layer_recrystallization": "capa de fosion",
    "surface_hoar_formation": "gibra de superfícia"
  },
  "recognizability": {
    "very_easy": "molt facil",
    "easy": "facil",
    "hard": "dificil",
    "very_hard": "molt dificil"
  },
  "distribution": {
    "isolated": "isolat",
    "specific": "especific",
    "widespread": "generalizat"
  },
  "probability": {
    "likely": "probable",
    "possible": "possible",
    "unlikely": "pòc probable"
  },
  "detailedDaytime": {
    "evening": "ser",
    "first_night_half": "prumèra meitat dera net",
    "second_night_half": "segona meitat dera net",
    "morning": "maitin",
    "forenoon": "maitin",
    "afternoon": "tarde"
  },
  "slopeGradient": {
    "moderately_steep": "moderadament arribent",
    "steep": "arribent",
    "very_steep": "fòrça arribent",
    "extremely_steep": "extrèmaments arribent"
  },
  "handHardness": {
    "fist": "P",
    "four_fingers": "4D",
    "one_finger": "1D",
    "pencil": "CR",
    "knife": "GI",
    "ice": "GÈU"
  },
  "hardnessTendency": {
    "decreasing": "mès trendre dejós",
    "steady": "uniforme",
    "increasing": "mès trendre dessús"
  },
  "terrainType": {
    "gullies_and_bowls": "canaus e cubetes",
    "adjacent_to_ridgelines": "adjacent as grinches",
    "distant_from_ridgelines": "luenh des grinches",
    "in_the_vicinity_of_peaks": "apròp des soms",
    "pass_areas": "apròp de còthi",
    "shady_slopes": "pales ombrères",
    "sunny_slopes": "pales solanères",
    "grassy_slopes": "pales erboses",
    "cut_slopes": "talussi",
    "wind_loaded_slopes": "pales acumulades peth vent",
    "base_of_rock_walls": "pè de parets rocassosses",
    "behind_abrupt_changes_in_the_terrain": "darrèr de cambis abruptes deth terren",
    "transitions_into_gullies_and_bowls": "transicions a canaus e cubetes",
    "areas_where_the_snow_cover_is_rather_shallow": "zònes on eth celh de nhèu ei fòrça escàs",
    "transitions_from_a_shallow_to_a_deep_snowpack": "transicions de nhèu escassa a nhèu prigonda",
    "highly_frequented_off_piste_terrain": "terren dehòra pista fòrça freqüentat",
    "little_used_backcountry_terrain": "terren de montanha pòc utilizat",
    "places_that_are_protected_from_the_wind": "lòcs emparadi deth vent",
    "regions_exposed_to_the_foehn_wind": "regions exposades ath vent de foehn",
    "regions_with_a_lot_of_snow": "regions damb fòrça nhèu",
    "regions_exposed_to_precipitation": "regions exposades ara precipitacion",
    "regions_exposed_to_heavier_precipitation": "regions exposades a precipitacion abondiua"
  },
  "dangerSign": {
    "shooting_cracks": "fissures damb propagacion",
    "whumpfing": "sons de \"whumpf\"",
    "fresh_avalanches": "lauegi recenti",
    "glide_cracks": "henerècles d'esguitlament"
  },
  "changeRegionDialog": {
    "message": "Vòs cambiar de region?",
    "accept": "Òc",
    "reject": "Non"
  },
  "zamg": {
    "table": "Taula",
    "map": "Mapa",
    "region": "Region",
    "newSnow": "Nhèu recenta"
  },
  "snowpack": {
    "plotType": {
      "LWC_stratigraphy": "nhèu umida: contengut d'aigua liquida",
      "wet_snow_instability": "nhèu umida: inestabilitat dera nhèu umida",
      "Sk38_stratigraphy": "coches fèbles persistentes: indèx estabilitat SK38",
      "stratigraphy": "coches fèbles persistentes: estratigrafia dera nhèu"
    },
    "aspect": {
      "flat": "plan",
      "north": "nòrd",
      "south": "sud"
    },
    "meteo": {
      "new_snow_plot_3day": "nhèu recènta (3d)",
      "new_snow_plot_7day": "nhèu recènta (7d)",
      "new_snow_plot_1month": "nhèu recènta (31d)",
      "new_snow_plot_season": "nhèu recènta (sason)",
      "new_snow_plot_forecast": "nhèu recènta (prediccion)",
      "wet_snow_plot_3day": "nhèu umida (3d)",
      "wet_snow_plot_7day": "nhèu umida (7d)",
      "wet_snow_plot_1month": "nhèu umida (31d)",
      "wet_snow_plot_season": "nhèu umida (sason)",
      "wet_snow_plot_forecast": "nhèu umida (prediccion)",
      "HS_table_24h": "taula nautada de nhèu (1d)",
      "HS_table_72h": "taula nautada de nhèu (3d)",
      "HS_table_season": "taula nautada de nhèu (sason)",
      "HS_table_forecast": "taula nautada de nhèu (prevision)",
      "TA_table_24h": "taula temperatura (1d)",
      "TA_table_72h": "taula temperatura (3d)",
      "TA_table_season": "taula temperatura (sason)"
    }
  },
  "grainShape": {
    "PP": {
      "code": "PP",
      "class": "Partícules de precipitacion"
    },
    "PPgp": {
      "code": "PPgp",
      "class": "Nhèu redona"
    },
    "DF": {
      "code": "DF",
      "class": "Partícules de precipitacion descompòstes e fragmentadas"
    },
    "RG": {
      "code": "RG",
      "class": "Grans fini"
    },
    "FC": {
      "code": "FC",
      "class": "Cristalhs facetadi"
    },
    "FCxr": {
      "code": "FCxr",
      "class": "Rounding Faceted Crystals"
    },
    "DH": {
      "code": "DH",
      "class": "Gobelets"
    },
    "SH": {
      "code": "SH",
      "class": "Gibra de superfícia"
    },
    "MF": {
      "code": "MF",
      "class": "Formes de fosion"
    },
    "MM": {
      "code": "MM",
      "class": "Machine Made"
    },
    "MFcr": {
      "code": "MFcr",
      "class": "Crosta de fosion-regèu"
    },
    "IF": {
      "code": "IF",
      "class": "Formacions de gèu"
    }
  },
  "button": {
    "true": "Òc",
    "false": "Non",
    "ok": "Òc ben",
    "yes": "Òc",
    "no": "Non"
  },
  "observations": {
    "$externalURL": "External URL (e.g. to photo database)",
    "$type": "Observation type",
    "allowEdit": "Editar observacion extèrna",
    "allowEditTooltip": "Açò evitarà es sobreescriptures de {{ value }}",
    "editIconTooltip": "Observacion editada - non arrecep actualizacions de {{ value }}",
    "aspect": "Orientacion",
    "authorName": "Nom de l'autor",
    "avalancheLength": "Longitud de lauet",
    "avalancheProblem": "Problèma de lauegi",
    "avalancheProblems": "Avalanche problem",
    "avalancheSize": "Mida de lauet",
    "avalancheType": "Tipe de lauet",
    "avalancheWidth": "Amplada de lauet",
    "search": "Cercar",
    "count": "# observacions:",
    "elevationTolerance": "Precision des donades d'elevacion",
    "elevationPeriod": "Periòde de temps de nautada",
    "layers": {
      "observers": "Observadors",
      "weatherStations": "Estacions meteorologiques",
      "webcams": "Webcams",
      "observations": "Observacions"
    },
    "weatherStations": {
      "tooltips": {
        "drySnowfallLevel": "Limit de nheuada seca",
        "globalRadiation": "Radiacion globau",
        "newSnow": "Nhèu recenta",
        "snowLine": "Limit de nhèu",
        "snowHeight": "Nautada de nhèu",
        "snowDifference": "Diferencia de nhèu",
        "airTemperature": "Temperatura der aire",
        "airTemperatureMax": "Temperatura der aire Max",
        "airTemperatureMin": "Temperatura der aire Min",
        "surfaceTemperature": "Temperatura de superfície",
        "surfaceHoar": "Potenciau de formacion deth Gibra de Superfícia",
        "surfaceHoarCalc": "Potenciau de formacion deth Gibra de Superfícia (Lehning et. al.)",
        "dewPoint": "Temperatura deth punt de rosada",
        "relativeHumidity": "Umiditat relativa",
        "windDirection": "Direccion deth vent",
        "windSpeed": "Velocitat deth vent",
        "windGust": "Bohada de vent"
      }
    },
    "webcams": {
      "tooltips": {
        "minusTenMinutes": "10min darrèr",
        "minusOneHour": "1or darrèr",
        "plusTenMinutes": "10min endauant",
        "plusOneHour": "1or endauant"
      }
    },
    "button": {
      "add": "íger observacion",
      "save": "Sauvar observacion",
      "delete": "Eliminar observacion",
      "deleteConfirm": "Eliminar observacion?",
      "discard": "Escartar",
      "copyDate": "Copiar data d'eveniment"
    },
    "comment": "Comentari",
    "content": "Contengut",
    "dangerPatterns": "Danger patterns",
    "dangerRating": "Grad de perilh",
    "dangerSource": "Hònt de perilh",
    "elevation": "Nautada",
    "elevationRange": "Banda de nautada",
    "elevationLowerBound": "Banda de nautada inferiora",
    "elevationUpperBound": "Banda de nautada superiora",
    "eventDate": "Data d'eveniment",
    "eventType": "Tipe d'eveniment",
    "eventTypes": {
      "IMPORTANT": "Eveniment important",
      "NEIGHBOR_REGION": "Region vesia",
      "NORMAL": "Eveniment normau",
      "PERSON_DEAD": "Eveniment damb persones implicades (mòrtes)",
      "PERSON_INJURED": "Eveniment damb persones implicades (herides)",
      "PERSON_NO": "Eveniment sense persones implicades",
      "PERSON_UNINJURED": "Eveniment damb persones implicades (il·leses)",
      "PERSON_UNKNOWN": "Eveniment (desconeishut)",
      "TRAFFIC": "Transit"
    },
    "externalURL": "URL extèrna (ex. tara base de donades de fòtos)",
    "fractureDepth": "Prigondor de cicatritz",
    "hasCoordinates": "A coordenades",
    "incline": "Inclinacion",
    "importantObservations": "Important observations",
    "latitude": "Latitud",
    "locationName": "Localitat",
    "longitude": "Longitud",
    "observationType": "Tipe d'observacion",
    "personInvolvement": "Implicacion de persones",
    "reportDate": "Data der infòrme",
    "showTable": "Taula",
    "stability": "Snowpack Stability",
    "withoutCoordinates": "Observacions sense coordenades:",
    "sidebar": {
      "filter": {
        "title": "Filtrar"
      },
      "legend": {
        "title": "Legenda"
      },
      "sources": {
        "title": "Hònts de donades"
      },
      "views": {
        "title": "Vistes"
      }
    }
  },
  "personInvolvement": {
    "Dead": "Eveniment damb persones implicades (mòrtes)",
    "Injured": "Eveniment damb persones implicades (herides)",
    "Yes": "Event involving persons",
    "No": "Eveniment sense persones implicades",
    "Uninjured": "Eveniment damb persones implicades (il·leses)",
    "Unknown": "Eveniment (desconeishut)"
  },
  "units": {
    "cm": "cm",
    "mm": "mm",
    "m": "m"
  },
  "qfa": {
    "day": "Dia",
    "time": "Òra",
    "back": "Darrèr",
    "parameters": {
      "DUST": "povàs saharià",
      "N": "cobertura de bromes totau en /8",
      "Nh": "cobertura de bromes nautes en /8",
      "Nm": "cobertura de bromes mejanes en /8",
      "Nl": "cobertura de bromes baishes en /8",
      "N-CU": "cobertura de bromes cumulus en /8",
      "AUSL.T": "temperatura desencadenant",
      "SHW-IX": "Índex Showalter",
      "WX -CUF": "temps significatiu: NIL (cap), RASH (ploja), TS (tempèsta)",
      "RR": "precipitacion totau [mm]",
      "RR-str": "precipitacion estratiforme",
      "CONV": "precipitacion convectiua [mm]",
      "SN": "precipitacion en forma de nhèu [mm]",
      "SN--RA": "límit dera nhèu [m]",
      "QAO ": "{{value}} hPa eq. vent mejan, direccion e velocitat, [°] e [m/s]",
      "QAN": "vent mejan en tèrra, direccion e velocitat, [°] e [m/s]",
      "QANmax": "vet màx. (bohades) en tèrra [m/s]",
      "T ": "{{value}} hPa eq. temperatura [°C]",
      "T m": "temperatura a {{value}}m [°C]",
      "T 2m": "temperatura a 2m [°C]",
      "Tk 2m": "temperatura a 2m [°K]",
      "T GND": "temperatura en tèrra",
      "Max-ADI": "temperatura maximala de barreja [°C]",
      "Min Max": "mín./màx. temperatura enes darrères 24ores",
      "FROST": "nautada isozèro [m]",
      "W cm": "500 hPa eq. vent verticau [cm/s]",
      "W --": "700 hPa eq. vent verticau [cm/s]",
      "W s": "{{value}} hPa eq. vent verticau [cm/s]",
      "H ": "{{value}} hPa nautada geopotenciau [m]",
      "RF ": "{{value}} hPa eq. umiditat relatiua [%]"
    }
  },
  "awsome": {
    "Aggregation band": "Banda d'agregacion",
    "Date": "Data",
    "Datetag": "Etiqueta de dia",
    "Depth": "Prigondor",
    "Dry instability": "Inestabilitat seca",
    "fair (<0.77)": "regular (<0.77)",
    "fair (<1.05)": "regular (<1.05)",
    "Grain type": "Tipe de gra",
    "LWC index": "Índex LWC",
    "New snow": "Nhèu recenta",
    "poor (<=3)": "praube (<=3)",
    "poor (<0.95)": "praube (<0.95)",
    "poor (>=0.77)": "praube (>=0.77)",
    "Punstable": "Punstable",
    "rather stable (<0.7)": "fòrça estable (<0.7)",
    "rather stable (<1)": "fòrça estable (<1)",
    "rather stable (>1.05)": "fòrça estable (>1.05)",
    "Size estimate": "Estimacion de mesura",
    "SK38 (RTA > 0.8)": "SK38 (RTA > 0.8)",
    "very poor (<=0.5)": "fòrça praube (<=0.5)",
    "very poor (>3)": "fòrça praube (>3)",
    "Wet instability": "Inestabilitat umida"
  },
  "channelStatus": {
    "loading": "Cargant eth canau d'estat dera informacion...",
    "triggerStatusChecks": "Desencadenar es comprovacions d'estat"
  },
  "lineaexport": {
    "searchfieldplaceholder": "Cercar estacions...",
    "hint": "Prémer Intro entà íger"
  },
  "awsstats": {
    "title": "AWS statistics",
    "label": {
      "loading": "Loading data...",
      "startDate": "Start date",
      "endDate": "End date",
      "selectWeatherStation": "Select weather station",
      "selectMicroRegions": "Select micro-regions",
      "clearselection": "Clear selection",
      "noMicroRegionsSelected": "cap",
      "last7days": "Last 7 days",
      "last30days": "Last 30 days",
      "last90days": "Last 90 days",
      "loadData": "Load data",
      "charttypes": "Chart types"
    },
    "charts": {
      "aws-observations": "AWS observations",
      "aws-danger-rating": "Grad de perilh",
      "aws-danger-rating-altitude": "Danger rating by altitude",
      "aws-avalanche-activity-index": "Avalanche activity index",
      "aws-danger-rating-danger-source-variants": "Danger source variants",
      "aws-danger-source-variants-matrix-parameter-stability": "Danger source variants stability",
      "aws-danger-source-variants-matrix-parameter-frequency": "Danger source variants frequency",
      "aws-danger-source-variants-matrix-parameter-avalanche-size": "Danger source variants avalanche size"
    },
    "error": {
      "startDateBeforeEndDate": "Start date must be before or equal to end date.",
      "failedLoadData": "Failed to load data for selected date range.",
      "startDateEndDateRequired": "Start date and end date are required."
    }
  },
  "yearlystats": {
    "title": "Yearly Statistics",
    "label": {
      "startDate": "Start date",
      "endDate": "End date",
      "loaddata": "Load data",
      "last90Days": "Last 90 days",
      "last180Days": "Last 180 days",
      "currentSeason": "Current season",
      "regionCode": "Region code",
      "allRegions": "TOTI",
      "virtualTrainings": "Virtual trainings (dates)",
      "fieldTrainings": "Field trainings (dates)",
      "dangerRatingReference": "Danger rating reference"
    },
    "charts": {
      "aws-danger-rating-micro-regions-bars": "AWS Danger Rating - Micro Regions - Bars",
      "aws-danger-rating-micro-regions": "AWS Danger Rating - Micro Regions",
      "aws-danger-rating-distribution": "AWS Danger Rating - Distribution",
      "aws-danger-pattern-micro-regions": "AWS Danger Pattern - Micro Regions",
      "aws-avalanche-problem-micro-regions": "AWS Avalanche Problem - Micro Regions",
      "aws-products": "AWS Products",
      "aws-stress-level": "Team Stress Level"
    },
    "hint": {
      "dangerRatingReference": "Reference values for a danger rating distribution over different seasons, shown in grey",
      "dateChange": "After changing the date, the 'Load data' button must be pressed."
    }
  },
  "zodForm": {
    "valid": "Valid",
    "required": "Required",
    "invalidNumber": "Please enter a valid number."
  }
}
